import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LogisticService } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-product-units-edit',
  templateUrl: './product-units-edit.component.html',
  styleUrls: ['./product-units-edit.component.css']
})
export class ProductUnitsEditComponent implements OnInit {
    private prodId: string | number;

    public setting?: Setting;

    public example?: Example;

    public selectListProductSizes: Item[] = [];

    public itemsListProductUnitDatas: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadSetting() {
        if (!!this.prodId) {
            this.setting = (await this.datatask.Post(585, { prod_id: this.prodId }))[0];
        }
    }

    private async loadExampleData() {
        if (!this.setting) return;

        this.example = (await this.datatask.Post(588, { prodsize_keyno: this.setting.prodsize_keyno }))[0];
    }

    private async loadProductSizes() {
        if (!!this.prodId) {
            this.selectListProductSizes = await this.logistic.getProductSizes(this.prodId);
        }
    }

    private async loadProductUnitDatas() {
        if (!this.setting) return;

        this.itemsListProductUnitDatas = await this.datatask.Post(586, { prodsize_keyno: this.setting.prodsize_keyno });
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'prodsize_keyno':
                if (!this.setting) return;

                this.loadExampleData();
                this.loadProductUnitDatas();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadExampleData();
        this.loadProductSizes();
        this.loadProductUnitDatas();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prodsize_keyno: string;
}

interface Example {
    exampledata: string;
}
